import { createApiSlice } from "@common";
import { CRUD_TIMELINE_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addTimelineStatus",
    method: "post",
    url: CRUD_TIMELINE_STATUS,
    stateKey: "message",
  },
  {
    name: "getTimelineStatus",
    method: "get",
    url: CRUD_TIMELINE_STATUS,
    stateKey: "data",
  },
  {
    name: "updateTimelineStatus",
    method: "put",
    url: CRUD_TIMELINE_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteTimelineStatus",
    method: "delete",
    url: CRUD_TIMELINE_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"timelineStatus",
 apiConfig, 
 customReducers);
const timelineStatusSlice = slice;

export default timelineStatusSlice.reducer;

export const {
  addTimelineStatus,
  getTimelineStatus,
  updateTimelineStatus,
  deleteTimelineStatus,
} = thunks;

export const { rowSelect } = actions;
